<template>
  <span
    style="display: inline-block;"
    class=""
  >
    <ElPopover
      :ref="'popper'"
      v-model:visible="poperVis"
      placement="top-end"
      trigger="click"
      width="auto"
    >
      <div class="message__wrapper">
        <p>{{ $t('paymentHistory.cancelPayRequest') }}?</p>
        <div class="!tw-flex !tw-justify-between">
          <button
            class="btn btn-outline-primary btn-sm mr-2 mb-0"
            @click="poperVis=false"
          >{{ $t('paymentHistory.no') }}</button>
          <button
            class="btn btn-danger btn-sm mb-0"
            @click="sendRequest(); poperVis=false"
          >{{ $t('paymentHistory.yes') }}</button>
        </div>
      </div>
      <template v-slot:reference>
        <button
          :loading="loading"
          :disabled="loading || disabled"
          class="btn btn-sm btn-outline-danger btn-req"
        >
          <i class="!tw-flex !tw-items-center fas fa-money-bill-wave mr-4" />
          {{ $store.state.payments.has_approved_not_paid_payment ? $t('paymentHistory.pendingPayments') : $t('paymentHistory.cancelPayRequest') }}
        </button>
      </template>
    </ElPopover>
  </span>
</template>

<script>

export default {
  components: {},
  props: ['changeSuccess', 'disabled'],
  emits: ['update:changeSuccess', 'refresh'],
  data() {
    return {
      active: false,
      loading: false,
      success: false,
      form: {},
      errors_: {},
      poperVis: false,
    };
  },
  watch: {
    active() {
      this.errors_ = {};
      this.form = {};
    },
  },
  methods: {
    sendRequest() {
      this.$api
        .postPaymentsHistoryCancelPaymentRequest({})
        .then((res) => {
          this.loading = false;
          this.success = true;

          this.$emit('refresh');
          this.$emit('update:changeSuccess', '');
          this.$alert.success(this.$t('paymentHistory.canceledRequest'));
        })
        .catch((err) => {
          this.loading = false;
          this.$alert.warning(this.$t('paymentHistory.canceledRequest'));
        });
    },
  },
};
</script>
